import { combineReducers } from 'redux'
import listPaymentLinks from './list-payment-links.store'
import paginatedListPaymentLinks from './paginated-list-payment-links.store'

export const rootReducer = combineReducers({
  listPaymentLinks,
  paginatedListPaymentLinks,
})
